import { useMediaQuery } from 'react-responsive';

const useIsPc = () => {
  const isPC = useMediaQuery({ minWidth: 1024 });
  return isPC;
};

export default useIsPc;
